import {PageContainer} from '@/components/organisms'
import {Accordion} from '@/components/molecules/Accordion'
import {
  GeneralDetails,
  DeliveryAndStatusInfo,
  SubItemAccordionContent,
  TransactionDetailsAccordionContent,
  DiscountInformationAccordionContent,
} from '@/containers'

const OrderItemTab = ({orderItemTabData}) => {
  const {
    generalDetails,
    deliveryAndStausInfo,
    subItemList,
    subItemColConfigData,
    transactionDetails,
    discountInformation,
  } = orderItemTabData || {}

  return (
    <>
      <PageContainer>
        <GeneralDetails generalDetails={generalDetails} />
        <DeliveryAndStatusInfo deliveryAndStausInfo={deliveryAndStausInfo} />
      </PageContainer>
      <div className="subItemAccordion">
        <Accordion
          isDark={true}
          content={<SubItemAccordionContent subItemAccordionData={{subItemList, subItemColConfigData}} />}
        />
      </div>
      <div className="transactionDetailsAccordion">
        <Accordion
          isDark={true}
          content={<TransactionDetailsAccordionContent transactionDetailsData={transactionDetails} />}
        />
      </div>
      <div className="discountInfoAccordion">
        <Accordion
          isDark={true}
          content={<DiscountInformationAccordionContent discountInfoList={discountInformation} />}
        />
      </div>
    </>
  )
}
export default OrderItemTab
